import React from "react";
import getTemporaryOrders from "../../TempData/Orders";
import DashboardSidebarMenu from "../../components/controls/DashboardSideBarMenu";
import OrdersTable from "../../components/tables/OrdersTable";
import { getAdminMenus } from "../../contexts/AdminMenus";
import { useTranslation } from "react-i18next";

const OrdersToValidate = () => {
  const { t } = useTranslation();
  const orders = getTemporaryOrders();
  const pendingOrders = orders.filter((order) => order.status === "pending");
  const menus = getAdminMenus();
  const title = t("admin.title");

  return (
    <div className="flex">
      <DashboardSidebarMenu menus={menus} title={title} />
      <div className="m-2 flex-grow">
        <h1 className="text-2xl font-bold text-onWhite py-4">
          Commandes en attente
        </h1>
        <OrdersTable orders={pendingOrders} status="pending" />
      </div>
    </div>
  );
};

export default OrdersToValidate;
